module.exports = __webpack_public_path__ + "img/tw-logo.c79710d5.svg";